export const sitePages = [
  {
    text: "Page d'accueil",
    value: "/",
  },
  
];
